var map = {
	"./AuthorLayout": 8139,
	"./AuthorLayout.tsx": 8139,
	"./ListLayout": 951,
	"./ListLayout.tsx": 951,
	"./PostLayout": 5104,
	"./PostLayout.tsx": 5104,
	"./PostSimple": 8218,
	"./PostSimple.tsx": 8218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9618;